import { format } from 'date-fns'
import { acceptHMRUpdate, defineStore } from 'pinia'
import { ref } from 'vue'

import api from '@/api'

export const useBookingStore = defineStore('booking', () => {
  const diners = ref<number | null>(null)
  const hour = ref<number | null>(null)
  const date = ref<string | null>(null)
  const promotionCode = ref<string | null>(null)
  const name = ref<string | null>(null)
  const surname = ref<string | null>(null)
  const email = ref<string | null>(null)
  const phone = ref<string | null>(null)
  const customerComments = ref<string | null>(null)
  const termsConditionsChecked = ref<boolean>(false)
  const marketingCommunicationChecked = ref<boolean>(false)
  const bookingId = ref<string | null>(null)
  const zone = ref<string | null>(null)

  function setDiners(value: number | null) {
    diners.value = value
    date.value = null
    hour.value = null
  }

  function setZone(value: string | null) {
    zone.value = value
  }

  function setHour(value: number | null) {
    hour.value = value
    zone.value = null
  }

  function setDate(value: string | null) {
    date.value = value
    hour.value = null
  }

  function setPromotionCode(value: string | null) {
    promotionCode.value = value
  }

  function setName(value: string | null) {
    name.value = value
  }

  function setSurname(value: string | null) {
    surname.value = value
  }

  function setEmail(value: string | null) {
    email.value = value
  }

  function setPhone(value: string | null) {
    phone.value = value
  }

  function setCustomerComments(value: string | null) {
    customerComments.value = value
  }

  function setTermsConditionsChecked(value: boolean) {
    termsConditionsChecked.value = value
  }

  function setMarketingCommunicationChecked(value: boolean) {
    marketingCommunicationChecked.value = value
  }

  function setBookingId(value: string | null) {
    bookingId.value = value
  }

  async function getBookingInfo() {
    if (!bookingId.value) {
      return
    }

    const response = await api.get(`/bookings/book/${bookingId.value}`)
    setBookingInfo(response.data)
  }

  function setBookingInfo({
    diners: newDiners,
    dateTime,
    promotionCode: newPromotionCode,
    zone: newZone,
    name: newName,
    surname: newSurname,
    email: newEmail,
    phoneNumber,
    customerComments: newCustomerComments
  }: any) {
    diners.value = newDiners
    zone.value = newZone
    hour.value = new Date(dateTime).valueOf()
    date.value = format(new Date(dateTime), 'yyyy-MM-dd')
    promotionCode.value = newPromotionCode
    name.value = newName
    surname.value = newSurname
    email.value = newEmail
    phone.value = phoneNumber
    customerComments.value = newCustomerComments
    termsConditionsChecked.value = true
  }

  function resetState() {
    diners.value = null
    hour.value = null
    date.value = null
    promotionCode.value = null
    name.value = null
    surname.value = null
    email.value = null
    phone.value = null
    customerComments.value = null
    termsConditionsChecked.value = false
    marketingCommunicationChecked.value = false
    zone.value = null
  }

  return {
    diners,
    hour,
    date,
    promotionCode,
    name,
    surname,
    email,
    phone,
    customerComments,
    termsConditionsChecked,
    marketingCommunicationChecked,
    bookingId,
    zone,

    setDiners,
    setZone,
    setHour,
    setDate,
    setPromotionCode,
    setName,
    setSurname,
    setEmail,
    setPhone,
    setCustomerComments,
    setTermsConditionsChecked,
    setMarketingCommunicationChecked,
    setBookingId,
    getBookingInfo,
    setBookingInfo,
    resetState
  }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useBookingStore, import.meta.hot))
}
